export const ACTIVE_CHAT_STATUSES = ["submitted", "streaming"] as const;
export const READY_CHAT_STATUSES = ["ready", "error"] as const;

type ActiveChatStatus = "submitted" | "streaming";
type ReadyChatStatus = "ready" | "error";
type ChatStatus = ActiveChatStatus | ReadyChatStatus;

export const isActiveChatStatus = (status: ChatStatus): status is ActiveChatStatus => {
  return ACTIVE_CHAT_STATUSES.includes(status as any);
};

export const isReadyChatStatus = (status: ChatStatus): status is ReadyChatStatus => {
  return READY_CHAT_STATUSES.includes(status as any);
};
